module.exports = __webpack_public_path__ + "static/media/phenotype.deb0f8f8.jpg";